import React from 'react';
import PropTypes from 'prop-types';

type Props = {
    style?              : any,
    className?          : string,
    inputClassName?     : string, //

    value               : string | number | null // PropTypes.any,            // cur Value string | number
    icon?               : any,
    button?             : any,
    disabled            : boolean,
    placeholder?        : string ,

    type                : 'text' | 'password' | 'number'

    pattern?            : string, //: PropTypes.string,
    step?               : string, // PropTypes.string,             //from number only

    commitDelay?        : number,
    trimValue           : boolean, //PropTypes.bool,
    autoSaveChanges     : boolean,      // if true will try to save changes while user is typing
    autoSaveOnUnmount?  : boolean,      // ???
    autoSaveOnBlur      : boolean,      // ???
    focusOnMount        : boolean,
    selectOnFocus       : boolean,

    onClick?            : callback
    onImmediateChange?  : callback,
    onFocus?            : callback,
    onBlur?             : callback,
    onChange?           : callback,            // on value change callback
    onEnter?            : callback,
    onEscape?           : callback
}

type State = {
    value       : any
}

export default class EditableInput extends React.Component<Props,State> {

    public commited             : boolean
    public debounceOnChange     : any
    public input                : any

    static defaultProps = {

        disabled                : false,
        type                    : 'text',

        commitDelay             : 600,
        trimValue               : true,
        autoSaveChanges         : false,
        autoSaveOnBlur          : true,
        autoSaveOnUnmount       : false,

        focusOnMount            : false,
        selectOnFocus           : false
    }



    constructor(props:any) {
        super(props);

        this.state = {
            value: this.props.value
        }

        this.commited = true;
    }

    UNSAFE_componentWillReceiveProps(newProps:any) {
        if (this.commited && this.state.value !== newProps.value)
            this.setState({value: newProps.value});
    }

    componentDidMount() {
        if (this.props.focusOnMount) {
            this.focus()
        }
        this.debounceOnChange = _.debounce(this.commitOnChange, this.props.commitDelay);
    }

    componentWillUnmount() {
        this.debounceOnChange.cancel();

        if (this.props.autoSaveOnUnmount) this.commitOnChange(this.state.value, true);
    }

    commitOnChange = (newValue:any, immediateSave = false) => {
        this.commited = true;
        if (this.props.type === 'text' && newValue && typeof newValue === 'string') {
            if (_.get(this.props, 'trimValue', true)) {
                newValue = newValue.trim();
            }
        }
        if (this.props.onChange) this.props.onChange(newValue, immediateSave);
    }

    focus = () => {
        this.input.focus()
    }
    blur = () => {
        this.input.blur()
    }

    getValue = () => {return this.state.value}
    select = () => {this.input.select()}

    onFocus = (e:any) => {
        if (this.props.selectOnFocus) this.input.select();
        if (this.props.onFocus) this.props.onFocus(e)
    }

    onBlur = (e:any) => {
        if (this.props.onBlur) this.props.onBlur(e);

        if (this.props.autoSaveChanges || this.props.autoSaveOnBlur){
            this.debounceOnChange.cancel();
            this.commitOnChange(this.state.value);
        }
    }

    onInputKeyDown = (event:any) => {
        switch (event.key) {
            case "Enter":
                if (this.props.onEnter) this.props.onEnter(this.state.value);
                else this.input.blur();

                if (!this.props.autoSaveChanges && !this.props.autoSaveOnBlur) this.commitOnChange(this.state.value);
                break;

            case "Escape":
                event.preventDefault();
                if (this.props.onEscape) this.props.onEscape();
                break;
        }
    }

    onChange = (event:any) => {
        this.commited = false;
        let newValue = event.target.value;

        if (this.props.autoSaveChanges) this.debounceOnChange(newValue);
        this.setState({value:newValue}, ()=>{
            if (this.props.onImmediateChange) this.props.onImmediateChange(newValue);
        });
    }

    render() {
        const classes = Classes(this.props.className, {
            empty: this.state.value === null || this.state.value === undefined
        });

        return (
            <div className  = {classes}
                 onClick    = {this.props.onClick}
            >
                {this.props.icon}
                <input ref={r=>this.input = r}
                       className={this.props.inputClassName}
                       style={this.props.style}
                       placeholder={this.props.placeholder}
                       value={!_.isNil(this.state.value) ? this.state.value : ""}
                       type={this.props.type}
                       pattern={this.props.pattern}
                       step={this.props.step}
                       disabled={this.props.disabled}
                       onKeyDown={this.onInputKeyDown}
                       onFocus={this.onFocus}
                       onBlur={this.onBlur}
                       onChange={this.onChange}/>
                {this.props.button}
            </div>
        );
    }
}
